import { createSlice } from '@reduxjs/toolkit';

import { projectInit } from 'actions';

export interface ScenariosPanelState {
  isScenariosPanelOpen: boolean;
}

const initialState: ScenariosPanelState = {
  isScenariosPanelOpen: false,
};

const scenariosPanelSlice = createSlice({
  name: 'scenariosPanel',
  initialState,
  reducers: {
    openScenariosPanel: state => {
      state.isScenariosPanelOpen = true;
    },
    closeScenariosPanel: state => {
      state.isScenariosPanelOpen = false;
    },
    toggleScenariosPanel: state => {
      state.isScenariosPanelOpen = !state.isScenariosPanelOpen;
    },
  },
  extraReducers: builder => {
    builder.addCase(projectInit, () => {
      return { ...initialState };
    });
  },
});

export const { openScenariosPanel, closeScenariosPanel, toggleScenariosPanel } =
  scenariosPanelSlice.actions;

export default scenariosPanelSlice.reducer;
